import _ from 'lodash';

const IS_DEV = process.env.NODE_ENV === 'development';
const WEBSITE_URL = 'https://glglz.v-1.co.il';
class ApiWorker {
	constructor() {
		this.token = null;
	}

	get token() {
		return this._token;
	}

	set token(val) {
		this._token = val;
	}

	getResFrame = () => ({
		data: null,
		success: false,
		message: '',
	});

	processError = e => {
		const result = this.getResFrame();

		if (e.error) {
			result.message = e.error;
		} else if (e.message) {
			result.message = e.message;
		} else {
			result.message = 'something went wrong';
		}

		return result;
	};

	send = async (url, method, body = null, secure = false) => {
		const targetUrl = IS_DEV ? `http://localhost:3100/api${url}` : `${WEBSITE_URL}/api${url}`;
		const headers = { 'Content-Type': 'application/json' };
		const options = { mode: 'cors' };
		let result = this.getResFrame();
		let response;
		let jsonResp;

		if (secure) {
			_.set(headers, 'Authorization', `Bearer ${this.token}`);
		}

		_.set(options, 'method', method);
		_.set(options, 'headers', headers);

		if (method !== 'GET') {
			_.set(options, 'body', JSON.stringify(body));
		}

		try {
			response = await fetch(targetUrl, options);

			jsonResp = await response.json();

			if (response.status === 200 || response.status === 204) {
				result.success = true;
				result.data = jsonResp.data;
			} else {
				throw new Error(jsonResp.error || jsonResp.message);
			}
		} catch (e) {
			result = this.processError(e);
		}

		return result;
	};

	post = async (url, body = {}, withToken = false) => {
		const targetUrl = IS_DEV ? `http://localhost:3100/api${url}` : `${WEBSITE_URL}/api${url}`;
		const headers = { 'Content-Type': 'application/json' };
		let result = this.getResFrame();
		let response;
		let jsonResp;

		if (withToken) {
			_.set(headers, 'Authorization', `Bearer ${this.token}`);
		}

		try {
			response = await fetch(targetUrl, {
				method: 'POST',
				mode: 'cors',
				headers,
				body: JSON.stringify(body),
			});

			jsonResp = await response.json();

			if (response.status === 200 || response.status === 204) {
				result.success = true;
				result.data = jsonResp.data;
			} else {
				throw new Error(jsonResp.error || jsonResp.message);
			}
		} catch (e) {
			result = this.processError(e);
		}

		return result;
	};

	get = async (url, withToken = false) => {
		// TODO: replace in future with cdn provided from Gil
		const targetUrl = IS_DEV ? `http://localhost:3100/api${url}` : `${WEBSITE_URL}/api${url}`;
		const headers = {};
		let result = this.getResFrame();
		let response;
		let jsonResp;

		if (withToken) {
			_.set(headers, 'Authorization', `Bearer ${this.token}`);
		}

		try {
			response = await fetch(targetUrl, {
				method: 'GET',
				mode: 'cors',
				headers,
			});

			jsonResp = await response.json();

			if (response.status === 200 || response.status === 204) {
				result.success = true;
				result.data = jsonResp.data;
			} else {
				throw new Error(jsonResp.error);
			}
		} catch (e) {
			result = this.processError(e);
		}

		return result;
	};
}

export default new ApiWorker();
